import api from '@/api';

function hasProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

export default {
  create: (fileData, config) => new Promise((resolve, reject) => {
    api({
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .post('/file', fileData, config)
      .then((response) => {
        if (hasProp(response.data.data, 'file')) {
          resolve({
            file: response.data.data.file[0],
            meta: response.data.meta,
          });
        }
      })
      .catch((error) => {
        console.log('files:api -> create -> catch..');

        if (error.response && hasProp(error.response.data.data, 'file')) {
          resolve({
            file: error.response.data.data.file[0],
            meta: error.response.data.meta,
          });
        } else {
          console.log('error1', {...error});
          reject(error.response);
        }
      });
  }),

  async read(fileId) {
    let running = false;
    let response;
    if (!running) {
      running = true;
      try {
        response = await api().get(`/file/${fileId}`);
        return Promise.resolve(response.data.data.file[0]);
      } catch(error) {
        if (error.response && hasProp(error.response.data.data, 'file')) {
          return Promise.resolve(error.response.data.data.file[0]);
        } else {
          return Promise.reject(error);
        }
      }
    }
  },

  // read: fileId => new Promise((resolve, reject) => {
  //   api()
  //     .get(`/file/${fileId}`)
  //     .then((response) => {
  //       resolve(response.data.data.file[0]);
  //     })
  //     .catch((error) => {
  //       if (error.response && hasProp(error.response.data.data, 'file')) {
  //         resolve(error.response.data.data.file[0]);
  //       } else {
  //         reject(error);
  //       }
  //     });
  // }),

  readLink: fileLink => new Promise((resolve, reject) => {
    api()
      .get(fileLink, {
        responseType: 'blob',
        timeout: false,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  }),

  delete: fileId => new Promise((resolve, reject) => {
    api()
      .delete(`/file/${fileId}`)
      .then((response) => {
        resolve(response.data.data.file[0]);
      })
      .catch((error) => {
        if (error.response && hasProp(error.response.data.data, 'file')) {
          resolve(error.response.data.data.file[0]);
        } else {
          reject(error);
        }
      });
  }),
};
